import { emptyObj } from '@beef/utils';
import { createSelector } from '@reduxjs/toolkit';
import { popupSteps } from "../../../../../store/common/constants";
import { ymOrderAlternativeTariffView, ymOrderTariffAddressView } from "../../analytics";
import { getAddressView, getModalTariffData, getTargetTariffType } from "./orderTariffCommon";
import { getCurrentFormStep } from "./modal";
export var getTariffDetails = function getTariffDetails(state) {
  return getModalTariffData(state).tariffData || emptyObj;
};
export var getIsHighSpeedTariff = function getIsHighSpeedTariff(state) {
  return getTargetTariffType(state).isHighSpeedTariff;
};
export var getCurrentStepWithAnalytics = createSelector([getCurrentFormStep, getTargetTariffType, getAddressView], function (step, tariffType, addressView) {
  if (step === popupSteps.addressRequestForm && !addressView) {
    ymOrderTariffAddressView('address_view', tariffType.tariffType);
  }
  if (step === popupSteps.alternativeTariff) {
    ymOrderAlternativeTariffView('tariff_view');
  }
  if (step === popupSteps.shortSuccess) {
    ymOrderAlternativeTariffView('tariff_operator');
  }
  return step;
});